import styled from 'styled-components';

const BreadcrumbWrapper = styled.div`
  margin-left: auto;
  margin-bottom: auto;
  margin-top: auto;

  @media screen and (max-width: 768px) {
    margin-top: 1rem;
    margin-left: 0;
  }
`;

export default BreadcrumbWrapper;
